module.exports = __webpack_public_path__ + "static/media/ok.a80a402c.svg";